import type { DriverMappingConfig } from './types';

export const NW_RATING_DEFAULT_TOOLTIP =
  "NerdWallet's ratings are determined by our editorial team. The scoring formulas take into account multiple data points for each financial product and service.";

export const DRIVER_LABEL_MAPPING: Record<string, DriverMappingConfig> = {
  fees: {
    label: 'Fees',
    marketplaceEntityKey: 'driverFees.value',
    marketplaceEntityDescriptionKey: 'driverFees.description',
  },
  options_contract_fee: {
    label: 'Options contract fee',
    marketplaceEntityKey: 'driverOptionsContractFee.value',
  },
  account_minimum: {
    label: 'Account minimum',
    marketplaceEntityKey: 'driverAccountMinimum.value',
    marketplaceEntityDescriptionKey: 'driverAccountMinimum.description',
  },
  promotion: {
    label: 'Promotion',
    marketplaceEntityKey: 'driverPromotion.value',
    marketplaceEntityDescriptionKey: 'driverPromotion.description',
  },
  ira_match: { label: 'IRA Match' },
  mobile_rating: { label: 'Mobile rating' },
  average_portfolio_expense_ratios: {
    label: 'Average portfolio expense ratios',
  },
  number_of_cryptocurrencies: { label: 'Number of cryptocurrencies' },
  accepts_nonaccredited_investors: {
    label: 'Accepts nonaccredited investors',
  },
};
